import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate(e) {
    window.Turbo.visit(e.currentTarget.value)
  }
}
